export const LINK_URL_MAX = 2000;
export const LINK_NAME_MAX = 50;
export const LINK_LIMIT = 10;

export type LinkField = {
  id: string;
  linkUrl?: string;
  linkName?: string;
};

export type SortableLinkRowProps = {
  field: LinkField;
  index: number;
  onRemove: (index: number) => void;
};
